module.exports = (function() {
	window.CallEmportalAPI = function(url, frm, options, dataLayerOpt) {
		var dataLayerForm=undefined;

		if(dataLayerOpt !== undefined) { //Need it for compatibility 
			var dataLayerForm = { 'event':'form',
			 'eventCategory':dataLayerOpt.FormTokenName,
			 'eventAction':'completed',
			 'eventLabel':dataLayerOpt.CampusName,
			 'eventFormName':dataLayerOpt.FormName,
			 'page_type':'lead'};
		}

		CallFormAPI(url, frm, options, dataLayerForm);
	}

	window.CallFormAPI = function(url, frm, options, dataLayerOpt) {
		CallFormAPI(url, frm, options, dataLayerOpt);
	}

	window.setEmportalAPIErrorsMsg = function(frm,ComponentName,Label,Message) {
		setEmportalAPIErrorsMsg(frm,ComponentName,Label,Message);
	};

	window.DisplayEmportalAPISuccess = function(frm) {
		DisplayEmportalAPISuccess(frm);
	};
})();

function CallFormAPI(url, frm, options, dataLayerOpt) {
	if (options == null) {
		options = {};
	}

	if (options.onPreProcess != null) {
		options.onPreProcess(frm);
	}

	$('#div' + frm + ' .udf-error').hide();

	$.blockUI({message: '<h4>'+$.i18n._(7801)+'</h4>'});

	$.ajax({
	type: "POST",
	url: url,
	dataType : "json",
	xhrFields: { withCredentials: true },
	data: $('#' + frm).serialize(),
		success: function(res) {
					switch(res.STATUS) {
						case
						 "VALID":
							if (options.OnSuccess != null) {
								if ($.isFunction(options.OnSuccess)) {
									options.OnSuccess(frm);
								} else {
									window[options.OnSuccess](frm);
								}
							}
							if(dataLayerOpt !== undefined){
								GAPush(dataLayerOpt);
							}
							break;
						case "INVALID":
							$('#div' + frm + '_ErrorReport').show();

							$('#ul' + frm + '_ErrorReport').html('');
							for (var ComponentName in res.ERRORS) {
								if (res.TYPE == 'INPUT') {
									setEmportalAPIErrorsMsg(frm,ComponentName, res.ERRORS[ComponentName].Label, res.ERRORS[ComponentName].ErrorMsg);
								}
								else {
									//CallEmportalAPI: unmanaged component error : %1 = %2
									alert($.i18n._(9718, [ComponentName, res.ERRORS[ComponentName]]));
								}
							}

							document.getElementById(frm + "_erroranchor").scrollIntoView();

							break;
						default:
							//CallEmportalAPI: unmanaged event error : %1
							alert($.i18n._(9719, [res.CODE]));
							break;
					}
					$.unblockUI();
		},
		error: function(callback) {
			res = $.parseJSON(callback.responseText);
			$.unblockUI();

			//CallEmportalAPI: unmanaged error : %1
			alert($.i18n._(9720, [res.status,res.logcode]));
		}
	});
}

function setEmportalAPIErrorsMsg(frm,ComponentName,Label,Message){
	$('#ul' + frm + '_ErrorReport').append($('<LI>').append(Label + ': ' + Message));
}

function DisplayEmportalAPISuccess(frm){
	$('#div' + frm + '_CMSTAG').html($.i18n._(9632));
}